var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-default"},[_c('BaseAlertsEnvironment'),_vm._v(" "),_c('BaseUiModal'),_vm._v(" "),_c('BaseLayoutHeaderSystem'),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('BaseLayoutFooter'),_vm._v(" "),_c('BaseAlertsCookies')],1)}
var staticRenderFns = []

export { render, staticRenderFns }